import config from "@/common/config"
const urls = {
	openid: "https://server.medflying.com/api/common/wx/openid",//openid
	jssign: 'https://server.medflying.com/api/common/wx/jssign',//获取js SDK
	oauth: '/wx/set_cookie_openid',//,//验证
  	agreementShare: `${config.host}/#/agreement`,//协议分享
	uploads: {
		// uploadFile: "/file_upload",
		uploadFile: "https://files.medflying.com/file_system/files",
		uploadAccept: "https://files.medflying.com/file_system/upload_accept",
		uploadComplete: "https://files.medflying.com/file_system/upload_complete",
		uploadFileTransfer: "https://files.medflying.com/file_system/files_transfer",
		// uploadBase64: "/api/uploadbase64",
		uploadBase64: "https://files.medflying.com/file_system/filesbase64",
		check_files: "/project/check_files"//检查文件是否重复
	},
	user: {
		code: "/api/sendsms",
    	users: "/forum/users",
		login: "/api/login"  // meetInfo
	},
	manager:{
		get_manager_list: config.host + '/back/manager_list',//获取RMM、RSM、DSM列表
		get_meet_manager: config.host + '/back/manager_apply', //超级管理员/RMM登录后的 审批列表
		get_meet_manager_info: config.host + '/back/manager_by_phone',//根据手机号获取管理员信息
		add_meet_creater:config.host + '/back/manager_apply',//会议创建人注册
		patch_meet_creater:config.host + '/back/manager_patch',//会议创建人修改
		audit_meet_creater_apply:config.host + '/back/manager_audit',//审批列表 审核
		change_meet_creater:config.host + '/back/manager_change',//会议创建人/专家对接人变更
		get_admin_user:config.host + '/back/admin/info'// 获取账号列表
	},
	live: {
		get_sign_history: "/live/sign_history", // 签到历史
		clear_sign_history: "/live/sign_info", // 清除签到历史
		signTime: "/live/sign_info", // 签到次数
		sign: "/live/sign", // 直播签到
		sign_info: "/live/sign_info", // 签到信息
		matchSignDoctor: "/live/match_sign_doctor",// 签到匹配  
	},
	chat:{
    	chatList:config.host + "/back/room/chat", //聊天记录列表
		doctor:config.host + "/back/room/meet_doctors", //聊天室中的会议专家
		send_profile: config.host + "/back/chat/send_profile",// 一键发送物料
    	detailAll: "/post_detail_all",//所有人都可以看的那种
    	sendMeetUserChat: config.host + "/back/msg_send_meet_chat_user",// 管理员 人员不足提醒 时长
    	sendMeetTimeChat: config.host + "/back/msg_send_meet_chat",// 管理员 会议提醒 时长
    	sendCommon: config.host + "/back/msg_send_common", // 通用模板
    	signUser:"/live/all_sign", // 签到人数
	},
	all: {
		hospital: "/user/hospital",//接口没有
		doctor_hospital_list: "/hospital/list",//医生信息页面筛选用到的医院列表
		doctor_hospital_list_with_code: "https://server.medflying.com/api/common/hospital/list_with_code"//医生信息页面筛选用到的医院列表 code维护
	},
	area:{
		area_list: config.host + '/back/area',
	},
	doctor: {
		info: "/doctor/info", // 保存和获取专家信息
		patch_doctor_info_new: "/doctor/info_new", // 专家列表修改专家信息
		delete: "/doctor/remove", // 删除专家
		match: "/doctor/match",// 智能匹配
		sign: "/doctor/meet_sign", // 签名
		agreement: "/doctor/meet_info", // 签名
		haveCourseware: "/doctor/have_courseware",
		courseware_list: "/list/class", // 课件列表
		doctor_material: "/doctor/material", // 材料信息
		doctor_list: config.host + '/back/doctor/list', //获取所有医生列表
		post_audit_doctor_job_info: config.host + '/back/doctor/examine_info', //医生职称审核
		post_doctor_job_info: config.host + '/back/doctor/patch_info', //医生职称修改
		post_audit_doctor_id_card: config.host + '/back/doctor/check_id_card', //医生身份证审核
		patch_audit_doctor_id_card: config.host + '/back/doctor/check_id_card', //医生身份证修改
	},
	meet:{
		get_meet_list: "/meet/month_static",// 日历中获取指定月份会议列表
    	create_meet: config.host + '/back/meet/create_meet',// 创建会议
		edit_meet: config.host + '/back/meet/info',// 修改会议
		meet_list: "/meet/list",//会议列表
		meet_filed_list: "/meet/filed",//会议领域列表
		meet_detail: "/meet/detail",//会议详情
		meet_info: "/meet/info",// 获取会议信息
		delete_meet:"/meet/delete_meet",//删除会议
		meet_filed:"/meet/filed",//会议领域列表
		meet_doctors:"/meet/doctors",//会议专家列表
		match_meet_doctors:"/doctor/match",//匹配会议专家
    	meet_detail: '/meet/detail',//会议详情
		meet_paper:"/meet/paper",//会议日报
		upload_class: "/meet/upload_class",
		submit: "/meet/commit",// 提交会议
		material_show_file: '/meet/show_file',//物料
		version: '/version/info', // 版本信息,
		meet_audit_detail:config.host + "/back/meet/audit_detail",//会议审核详情
		meet_profile_detail:config.host + "/back/forum/profile",//获取物料详情
		patch_link: '/link/info',//环节标题修改
		patch_process: '/process/info',//议程标题修改
		patch_module: '/module/info',//模块标题修改
		patch_team: '/team/info',//团队修改
    	get_meet_users: config.host + "/back/chat/get_meet_users", // 获取登录用户是否拥有访问&修改指定会议的权限

		help: '/help/info',// 增加，删除，修改协作人
		rollback: '/version/rollback', //回滚版本
		link_times: "/meet/links", // 没有会议时间时虚构的环节时间
		auditMoney: config.host + "/back/meet/audit_money", //协办人审核金额
		exchangeTeamDoctor: config.host + '/back/exchange/team/doctor', //交换团队医生顺序
		exchangeLinkDoctor: config.host + '/back/exchange/link/doctor', //交换专家顺序 
		exchangeAnchorwomanDoctor: config.host + "/back/exchange/anchorwoman/doctor",//交换主持专家顺序 
		bindDoctorPhone: '/meet/doctor/bind/phone'//绑定专家负责人接口
	}
}
export default urls;